import React from 'react';
import * as Styles from './faq.css';

const Faq = (props) => {
    const data = Array(5).fill({
        title: 'Lorem Ipsium?',
        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.'
    });
    return (
        <Styles.FaqWrapper>
            <div className="container">
                <Styles.FaqHeader>
                    Frequently Asked Questions
            </Styles.FaqHeader>
                <Styles.Column>
                    {data.map((item, index) => {
                        return (
                            <>
                            <Styles.FaqMinihead key={index} >
                                {item.title}
                            </Styles.FaqMinihead>
                            <Styles.FaqSubhead key={index * 10 + 10} >
                                {item.body}
                            </Styles.FaqSubhead>
                        </>
                        )
                    })}
                </Styles.Column>
            </div>
        </Styles.FaqWrapper>
    );
}
export default Faq;